// src/plugins/image-url.js
export default {
  install(Vue) {
    Vue.prototype.$imageBaseUrl = 'http://localhost:9558';
  }
}
